import { useEffect } from "react";
import { Grid } from "@mui/material";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";

export const FirmaProfesional = ({
    allowedWrite,
    isNew,
    datosSeleccionFormData,
    handleChange,
    handlePreview,
    handleChangeArchivo,
    handleDelete
}) => {

    useEffect(() => {
        handleChange('firmaPersonalCheck', !!datosSeleccionFormData?.firmaDigital);
    }, [datosSeleccionFormData?.firmaDigital]);

    return (
        <div className='generic-tab-container container-separate'>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <div className='generic-header-tab-content-with-buttons'>
                        <strong>Firma Profesional</strong>
                    </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 8, md: 4, lg: 4 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'custom_switch',
                            name: 'firmaPersonalCheck',
                            displayName: 'Firma',
                            disabled: true
                        }}
                        handleChange={handleChange}
                        value={datosSeleccionFormData.firmaPersonalCheck}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 8, md: 6, lg: 6 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'file',
                            name: 'firmaDigital',
                            displayName: 'Adjuntar firma personal',
                            validExtensions: ['PNG', 'JPG'],
                            maxFileSize: 1,
                            combineAsPdf: false,
                            disabled: !allowedWrite,
                            multiple: false
                        }}
                        handleChange={handleChangeArchivo}
                        handleDelete={handleDelete}
                        value={datosSeleccionFormData.firmaDigital}
                    />
                </Grid>
            </Grid>
        </div>
    );
}